<template>
  <v-container fluid class="tp-page">
    <div class="tp-page-head">
      <div>
        <h1 class="tp-page-title">Minha Igreja</h1>
        <p class="tp-page-sub">Dados que aparecem para quem acessa seus links públicos.</p>
      </div>
      <div class="tp-head-actions">
        <v-btn color="#00695C" dark depressed rounded :loading="salvando" @click="salvar">
          <v-icon left>mdi-content-save-outline</v-icon>Salvar
        </v-btn>
      </div>
    </div>

    <v-row v-if="!igrejaId">
      <v-col cols="12">
        <v-alert type="warning" outlined>Sua conta não está vinculada a uma igreja.</v-alert>
      </v-col>
    </v-row>

    <v-row v-else>
      <!-- Identidade -->
      <v-col cols="12" md="8">
        <v-card class="tp-card" elevation="0" style="padding: 18px 20px;">
          <p class="mi-section">Identidade</p>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="igreja.nome" label="Nome da igreja" outlined dense color="#00695C" hide-details="auto" class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="igreja.cnpj" label="CNPJ" outlined dense color="#00695C" hide-details="auto" class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="igreja.endereco" label="Endereço" outlined dense color="#00695C" hide-details="auto" class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="igreja.logoUrl" label="URL do logo (link de uma imagem)" outlined dense color="#00695C" hide-details="auto" prepend-inner-icon="mdi-image-outline"></v-text-field>
              <div class="mi-logo-actions">
                <v-btn small text color="#00695C" @click="dialogLogo = true"><v-icon left small>mdi-upload</v-icon>Enviar imagem</v-btn>
                <v-btn v-if="igreja.logoUrl" small text color="error" @click="igreja.logoUrl = ''"><v-icon left small>mdi-close</v-icon>Remover</v-btn>
                <span class="mi-logo-hint">Cole um link acima ou envie uma imagem do seu dispositivo.</span>
              </div>
            </v-col>
          </v-row>

          <p class="mi-section mt-4">Contato</p>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="igreja.telefone" label="Telefone" outlined dense color="#00695C" hide-details="auto" v-mask="'(##) #####-####'" type="tel" class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="igreja.whatsapp" label="WhatsApp" outlined dense color="#00695C" hide-details="auto" v-mask="'(##) #####-####'" type="tel" class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="igreja.email" label="E-mail" outlined dense color="#00695C" hide-details="auto" type="email" class="mb-3"></v-text-field>
            </v-col>
          </v-row>

          <p class="mi-section mt-4">Redes sociais</p>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field v-model="igreja.instagram" label="Instagram (link)" outlined dense color="#00695C" hide-details="auto" prepend-inner-icon="mdi-instagram" class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="igreja.facebook" label="Facebook (link)" outlined dense color="#00695C" hide-details="auto" prepend-inner-icon="mdi-facebook" class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="igreja.youtube" label="YouTube (link)" outlined dense color="#00695C" hide-details="auto" prepend-inner-icon="mdi-youtube" class="mb-3"></v-text-field>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <!-- Pré-visualização -->
      <v-col cols="12" md="4">
        <v-card class="tp-card" elevation="0" style="padding: 18px 20px;">
          <p class="mi-section">Pré-visualização</p>
          <div class="mi-preview">
            <img v-if="igreja.logoUrl" :src="igreja.logoUrl" class="mi-logo" @error="logoErro = true" />
            <div v-else class="mi-logo-fallback">{{ (igreja.nome || 'Templus') }}</div>
            <p v-if="logoErro" class="mi-erro">Não foi possível carregar a imagem desse link.</p>
            <p class="mi-nome">{{ igreja.nome }}</p>
          </div>
        </v-card>
      </v-col>

      <!-- Assinatura & cobrança (igrejas de autocontratação) -->
      <v-col cols="12" v-if="igreja.autocontratacao === true">
        <v-card class="tp-card" elevation="0" style="padding: 18px 20px;">
          <div class="mi-plano-head">
            <p class="mi-section" style="margin:0;">Assinatura &amp; cobrança</p>
            <v-chip small label :color="igreja.ativo ? '#E3F3EE' : '#FDECC8'" :text-color="igreja.ativo ? '#1E7A5E' : '#9A6B00'">
              <v-icon left small>{{ igreja.ativo ? 'mdi-check-circle' : 'mdi-clock-alert-outline' }}</v-icon>
              {{ igreja.ativo ? 'Assinatura ativa' : 'Não ativada' }}
            </v-chip>
          </div>
          <p class="mi-hint">
            O valor varia conforme o porte da sua igreja. A cobrança é mensal, via PIX.
          </p>
          <template v-if="igreja.ativo">
            <!-- Plano é somente leitura (alterar exige suporte) -->
            <v-row align="center">
              <v-col cols="12" md="7">
                <p class="mi-cob-label">Porte da igreja (faixa de membros)</p>
                <p class="mi-cob-val">{{ planoSelecionado ? planoSelecionado.faixa : '—' }}</p>
              </v-col>
              <v-col cols="12" md="5">
                <div class="mi-valor">
                  <span class="mi-valor-num">{{ valorPlanoLabel }}</span>
                  <span class="mi-valor-sufixo" v-if="planoSelecionado">{{ planoSelecionado.sufixo }}</span>
                </div>
              </v-col>
              <v-col cols="12">
                <p class="mi-hint" style="margin:0">Para alterar o plano da sua igreja, entre em contato com o suporte.</p>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <div class="mi-cob">
              <div class="mi-cob-item">
                <p class="mi-cob-label">Próxima cobrança</p>
                <p class="mi-cob-val">{{ proximaCobrancaLabel }}</p>
              </div>
              <div class="mi-cob-item">
                <p class="mi-cob-label">Forma de cobrança</p>
                <p class="mi-cob-val">PIX</p>
              </div>
            </div>

            <template v-if="historicoPagamentos.length">
              <p class="mi-section mt-5">Histórico de mensalidades</p>
              <div class="mi-hist">
                <div class="mi-hist-row" v-for="h in historicoPagamentos" :key="h.id">
                  <span class="mi-hist-data">{{ dataHist(h) }}</span>
                  <span class="mi-hist-valor">{{ formatarValor(h.valor) }}</span>
                  <v-chip x-small label :color="h.statusPagamento === 'PAGO' ? '#E3F3EE' : '#FDECC8'" :text-color="h.statusPagamento === 'PAGO' ? '#1E7A5E' : '#9A6B00'">
                    {{ h.statusPagamento === 'PAGO' ? 'Pago' : 'Pendente' }}
                  </v-chip>
                </div>
              </div>
            </template>
          </template>

          <!-- Situação atípica: assinatura não configurada -->
          <template v-else>
            <p class="mi-hint" style="margin-top:0">A assinatura da sua igreja ainda não está configurada. Entre em contato com o suporte para regularizar o acesso.</p>
          </template>
        </v-card>
      </v-col>

      <!-- Links públicos da igreja -->
      <v-col cols="12">
        <v-card class="tp-card" elevation="0" style="padding: 18px 20px;">
          <p class="mi-section">Link público</p>
          <p class="mi-hint">Esta é a página que reúne todos os cadastros e acessos da sua igreja. Compartilhe com a sua congregação.</p>
          <v-row>
            <v-col cols="12" md="6" v-for="link in links" :key="link.key">
              <div class="mi-link">
                <div class="mi-link-head">
                  <v-icon left color="#00695C">{{ link.icon }}</v-icon>
                  <span class="mi-link-titulo">{{ link.titulo }}</span>
                </div>
                <v-text-field :value="link.url" readonly outlined dense hide-details color="#00695C" class="mt-2"></v-text-field>
                <div class="mi-link-actions">
                  <v-btn small text color="#00695C" @click="copiar(link.url)"><v-icon left small>mdi-content-copy</v-icon>Copiar</v-btn>
                  <v-btn small text color="#00695C" :href="link.url" target="_blank"><v-icon left small>mdi-open-in-new</v-icon>Abrir</v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- Upload/recorte do logo -->
    <v-dialog v-model="dialogLogo" max-width="560px" persistent>
      <v-card class="tp-card" elevation="0">
        <v-card-title><span class="mi-serif">Enviar logo</span></v-card-title>
        <v-card-text>
          <vueAnkaCropper
            :options="{
              aspectRatio: false,
              closeOnSave: true,
              cropArea: 'box',
              croppedWidth: 512,
              croppedHeight: false,
              cropperHeight: false,
              dropareaMessage: 'Arraste uma imagem aqui ou escolha do dispositivo',
              maxFileSize: 4000000,
              resultQuality: 0.9,
              resultMimeType: 'image/png',
              selectButtonLabel: 'Escolher imagem',
              showPreview: true,
              skin: 'light',
              uploadData: {},
              uploadTo: false
            }"
            @cropper-error="erroLogo($event)"
            @cropper-saved="salvarLogo($event)"
            @cropper-cancelled="dialogLogo = false"
          ></vueAnkaCropper>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn text color="#5b6b67" @click="dialogLogo = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar ref="chamaSnackbar" />
  </v-container>
</template>

<script>
import axios from 'axios'
import { baseApiUrl } from '@/global'
import Snackbar from '../componentes/snackbar.vue'
import { mapState } from 'vuex'
import { formatBRL, planoPorId } from '@/plans'
import vueAnkaCropper from 'vue-anka-cropper'

export default {
  name: 'MinhaIgreja',
  components: { Snackbar, vueAnkaCropper },
  data() {
    return {
      igreja: {},
      salvando: false,
      logoErro: false,
      dialogLogo: false,
      temAssinatura: false,
      assinaturaInfo: null,
      historicoPagamentos: [],
    }
  },
  computed: {
    ...mapState({ user: state => state.userObj }),
    igrejaId() {
      if (this.user && this.user.igrejaId) return this.user.igrejaId
      // Fallback: acesso direto/refresh antes do Vuex popular o usuário.
      try {
        const u = JSON.parse(sessionStorage.getItem('user'))
        return u && u.igrejaId ? u.igrejaId : ''
      } catch (e) {
        return ''
      }
    },
    planoSelecionado() {
      return planoPorId(this.igreja.planoId)
    },
    valorPlanoLabel() {
      return this.planoSelecionado ? formatBRL(this.planoSelecionado.valor) : '—'
    },
    proximaCobrancaLabel() {
      const p = this.assinaturaInfo && this.assinaturaInfo.proximaCobranca
      if (!p) return '—'
      const d = new Date(p)
      return isNaN(d) ? p : d.toLocaleDateString('pt-BR')
    },
    links() {
      const base = window.location.origin
      const id = this.igrejaId
      return [
        { key: 'hub', titulo: 'Página de links da sua igreja', icon: 'mdi-link-variant', url: `${base}/links?igrejaId=${id}` },
      ]
    },
  },
  mounted() {
    if (this.igrejaId) this.carregar()
  },
  watch: {
    'igreja.logoUrl'() { this.logoErro = false },
  },
  methods: {
    async carregar() {
      const token = sessionStorage.getItem('accToken')
      try {
        const res = await axios.get(`${baseApiUrl}Igrejas/${this.igrejaId}?access_token=${token}`)
        if (res.data) this.igreja = res.data
      } catch (e) {
        this.$refs.chamaSnackbar.snack('#EF5350', 'Erro ao carregar os dados da igreja.', 'ERRO')
      }
      // Card de plano só aparece para igrejas com assinatura (autocontratação).
      // Igrejas antigas (ex.: Liberdade) não têm registro e o card fica oculto.
      try {
        const st = await axios.get(`${baseApiUrl}Pagamentos/statusAssinatura?igrejaId=${this.igrejaId}&access_token=${token}`)
        this.temAssinatura = !!(st.data && st.data.statusPagamento && st.data.statusPagamento !== 'NENHUM')
      } catch (e) {
        this.temAssinatura = false
      }
      // Resumo da assinatura (valor, próxima cobrança) + histórico de mensalidades.
      if (this.temAssinatura) {
        try {
          const res = await axios.get(`${baseApiUrl}Pagamentos/resumoAssinatura?igrejaId=${this.igrejaId}&access_token=${token}`)
          this.assinaturaInfo = (res.data && res.data.assinatura) || null
          this.historicoPagamentos = (res.data && res.data.historico) || []
        } catch (e) { /* mantém só o status básico */ }
      }
    },
    formatarValor(v) {
      const n = Number(String(v || '').replace(',', '.'))
      if (!isFinite(n) || n <= 0) return '—'
      return 'R$ ' + n.toFixed(2).replace('.', ',')
    },
    dataHist(h) {
      const d = new Date(h.dataHoraPagamento || h.created)
      return isNaN(d) ? '—' : d.toLocaleDateString('pt-BR')
    },
    // Recorte concluído: o cropper devolve a imagem em base64 (data URL),
    // que é gravada direto no logoUrl (mesmo padrão usado no resto do sistema).
    salvarLogo(event) {
      this.igreja.logoUrl = event.croppedImageURI
      this.logoErro = false
      this.dialogLogo = false
      this.$refs.chamaSnackbar.snack('#2E9E78', 'Logo carregado! Clique em Salvar para aplicar.', 'SUCESSO')
    },
    erroLogo(event) {
      const e = String(event || '')
      if (e.substring(0, 5) === 'Wrong') {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Apenas imagens são permitidas.', 'ATENÇÃO')
      } else if (e.substring(0, 4) === 'File') {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Imagem muito grande. Máximo de 4MB.', 'ATENÇÃO')
      } else {
        this.$refs.chamaSnackbar.snack('#EF5350', 'Não foi possível carregar a imagem.', 'ERRO')
      }
    },
    async copiar(url) {
      try {
        await navigator.clipboard.writeText(url)
        this.$refs.chamaSnackbar.snack('#2E9E78', 'Link copiado!', 'SUCESSO')
      } catch (e) {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Não foi possível copiar. Selecione e copie manualmente.', 'ATENÇÃO')
      }
    },
    async salvar() {
      if (!this.igreja.nome) {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Informe o nome da igreja.', 'ATENÇÃO')
        return
      }
      // Envia apenas identidade/contato. Plano, mensalidade e status da
      // assinatura são controlados pelo fluxo de pagamento — nunca por aqui
      // (o backend também bloqueia esses campos em updates comuns).
      const payload = {
        nome: this.igreja.nome,
        cnpj: this.igreja.cnpj,
        endereco: this.igreja.endereco,
        logoUrl: this.igreja.logoUrl,
        telefone: this.igreja.telefone,
        whatsapp: this.igreja.whatsapp,
        email: this.igreja.email,
        instagram: this.igreja.instagram,
        facebook: this.igreja.facebook,
        youtube: this.igreja.youtube,
      }

      this.salvando = true
      try {
        await axios.patch(`${baseApiUrl}Igrejas/${this.igrejaId}?access_token=${sessionStorage.getItem('accToken')}`, payload)
        this.$refs.chamaSnackbar.snack('#2E9E78', 'Dados salvos com sucesso!', 'SUCESSO')
      } catch (e) {
        this.$refs.chamaSnackbar.snack('#EF5350', 'Erro ao salvar. Verifique os dados e tente novamente.', 'ERRO')
      } finally {
        this.salvando = false
      }
    },
  },
}
</script>

<style scoped>
@import '../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css';
.mi-section { font-size: .74rem; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; color: #00695C; margin: 0 0 12px; }
.mi-logo-actions { display: flex; align-items: center; flex-wrap: wrap; gap: 4px; margin-top: 6px; }
.mi-logo-hint { color: #97a3a0; font-size: .8rem; margin-left: 4px; }
.mi-plano-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin: 0 0 10px; flex-wrap: wrap; }
.mi-preview { text-align: center; padding: 10px 0; }
.mi-logo { max-width: 100%; max-height: 120px; object-fit: contain; }
.mi-logo-fallback { font-family: 'Fraunces', Georgia, serif; font-size: 1.4rem; color: #16322E; padding: 18px 0; }
.mi-nome { margin: 12px 0 0; font-weight: 600; color: #16322E; }
.mi-erro { color: #EF5350; font-size: .8rem; margin: 8px 0 0; }
.mi-hint { color: #5b6b67; font-size: .9rem; margin: -6px 0 12px; }
.mi-valor { display: flex; align-items: baseline; gap: 6px; }
.mi-valor-num { font-family: 'Fraunces', Georgia, serif; font-weight: 700; font-size: 1.7rem; color: #00695C; }
.mi-valor-sufixo { color: #5b6b67; font-size: .95rem; }
.theme--dark .mi-valor-num { color: #5BC1A3; }
.mi-link { border: 1px solid var(--tp-line); border-radius: 12px; padding: 12px 14px; }
.mi-link-head { display: flex; align-items: center; font-weight: 600; color: #16322E; }
.mi-link-titulo { font-size: .95rem; }
.mi-link-actions { display: flex; gap: 8px; margin-top: 6px; }
.mi-cob { display: flex; gap: 40px; flex-wrap: wrap; }
.mi-cob-label { font-size: .74rem; color: #5b6b67; margin: 0; }
.mi-cob-val { font-weight: 600; color: #16322E; margin: 2px 0 0; }
.mi-hist { display: flex; flex-direction: column; gap: 8px; }
.mi-hist-row { display: flex; align-items: center; gap: 12px; padding: 8px 12px; border: 1px solid var(--tp-line); border-radius: 10px; }
.mi-hist-data { color: #5b6b67; font-size: .9rem; min-width: 92px; }
.mi-hist-valor { font-weight: 600; color: #16322E; flex: 1; }
.mi-serif { font-family: 'Fraunces', Georgia, serif; font-weight: 600; font-size: 1.2rem; color: #16322E; }
.mi-cob-info { display: flex; align-items: flex-start; gap: 6px; background: #E9F6F0; border: 1px solid #cfe9df; border-radius: 12px; padding: 12px 14px; color: #1E7A5E; font-size: .9rem; margin: 4px 0 16px; }
.theme--dark .mi-cob-val, .theme--dark .mi-hist-valor { color: #eaf2ef; }
.theme--dark .mi-cob-label { color: rgba(255,255,255,.65); }
.theme--dark .mi-hist-row { border-color: rgba(255,255,255,.12); }
.theme--dark .mi-logo-fallback, .theme--dark .mi-nome, .theme--dark .mi-link-head { color: #eaf2ef; }
.theme--dark .mi-hint { color: rgba(255,255,255,.65); }
.theme--dark .mi-link { border-color: rgba(255,255,255,.12); }
</style>
